<template>
  <div class="tw-flex tw-flex-col">
    <div class="tw-w-4 tw-h-5 tw-border-l tw-border-core-primary-80" />
    <div class="tw-w-4 tw-h-5 tw-border-l tw-border-b tw-border-core-primary-80" />
    <div class="tw-w-4 tw-h-5" />
  </div>
</template>

<script>
export default {
  name: "LShapeComponent",
}
</script>
